import { agent } from 'src/api/agent';
import { throwApiError } from 'src/api/utils';
import { apiV2Agent } from 'src/api/V2agent';

import type { TTheWell } from './types';

export class WellsServiceApi {
  async fetchWells(planVersionId: number): Promise<TTheWell[]> {
    try {
      const { data } = await apiV2Agent.get<TTheWell[]>('/core/wells', {
        params: {
          planVersionId,
          includeUnplanned: true,
        },
      });

      return data;
    } catch (e) {
      throwApiError(e);
    }
  }

  async deleteWells(planVersionId: number, wellsIds: number[]): Promise<void> {
    try {
      await agent.delete('/well', {
        params: {
          planVersionId,
        },
        data: wellsIds,
      });
    } catch (e) {
      throwApiError(e);
    }
  }
}
